import excelJS from 'exceljs'
import { save } from 'save-file'
import applyDefaultWorkbookView from '/utils/excel-workbook-view'
import moment from 'moment-timezone'
import { getVisibleExportColumns } from '/utils/export-data'

const columns = [
  {name:"Template ID",item:"id",width:100},
  {name:"Template Name",item:"name",width:100},
  {name:"Template Group",item:"group_id",width:100},
  {name:"Smartix Scanner Compatible",item:"managed_pass_template",width:25, format:"yes"},
  {name:"Live Passes Issued",item:"live_passes_issued",width:50},
  {name:"Num Active Passes",item:"num_live_active_passes",width:50},
  {name:"Num Apple Installed Passes",item:"live_passes_installed_apple",width:50},
  {name:"Num Google Installed Passes",item:"live_passes_installed_google",width:50},
  {name:"Affected passes (Apple)",item:"apple_sync_count",width:50},
  {name:"Affected passes (Google)",item:"google_sync_count",width:50},
  {name:"Num Test Passes passes",item:"test_passes_issued",width:50},
  {name:"Created",item:"creation_date",width:50, format:"date"},
  {name:"Last Modified",item:"last_modified_date",width:50, format:"date"},
]

const templateListToExcel = async ({ fileName, data, visibleColumns }) => {
  const exportColumns = getVisibleExportColumns(columns, visibleColumns)

  const workbook = new excelJS.Workbook()

  workbook.views = [
    {
      x: 0, y: 0, width: 3, height: 1000,
      firstSheet: 0, activeTab: 1, visibility: 'visible'
    }
  ]

  const font = { name: 'Courier', size: 12, bold: true }

  for (let key in data) {
    const dataItem = data[key]
    if (dataItem.length) {

      const passes_worksheet = workbook.addWorksheet(key)

      exportColumns.map((col,idx) => passes_worksheet.getColumn(idx+1).width = col.width)

      const passes_row = passes_worksheet.getRow(1)

      exportColumns.map((col,idx) => passes_row.getCell(idx+1).value = col.name)

      exportColumns.map((col,idx) => passes_row.getCell(idx+1).font = font)

      dataItem.map((r, i) => {
        const row = passes_worksheet.getRow(i + 2)
      
        exportColumns.map((col,idx) => row.getCell(idx+1).value = col.format ? formatDataItem(r,col): r[col.item])
        exportColumns.map((col,idx) => row.getCell(idx+1).font = font)
      })
    }
  }


  applyDefaultWorkbookView(workbook)
  const buffer = await workbook.xlsx.writeBuffer()

  await save(buffer, fileName + '.xlsx')
}

export default templateListToExcel

const formatDataItem = (row,col) => {

  const value = row[col.item]

  switch (col.format) {
    case "date" : return moment(value).format("YYYY-MM-DD HH:mm")
    case "yes" : return value === 1 ? "yes" : ""
  }
}
